export default "__VITE_ASSET__382a19b2__"